import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { NewMonitoringValutazioniService } from "./dataService/service";
import { GetAllValutazioniFiltersDTO, GetAllValutazioniResponseData } from "./dataService/dto";

interface MonitoringValutazioniState {
    // FILTERS
    GetAllValutazioniFilters: GetAllValutazioniFiltersDTO
    getAllValutazioniStatus: PromiseStatuses
    GetAllValutazioniResponse?: GetAllValutazioniResponseData[]
}

const initialState: MonitoringValutazioniState = {

    GetAllValutazioniFilters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllValutazioniStatus: 'idle',
}

export const GetAllValutazioni = createAsyncThunk(
    'monitoringValutazioni/GetAllValutazioni',
    async (filters: GetAllValutazioniFiltersDTO, thunkApi): Promise<GetAllValutazioniResponseData[]> => {
        const monitoringValutazioniService = NewMonitoringValutazioniService()

        return monitoringValutazioniService.GetAllValutazioni(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const MonitoringValutazioniSlice = createSlice({
    name: 'monitoringValutazioni/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllValutazioniFiltersItemsPerPage: (state, action) => {
            state.GetAllValutazioniFilters.itemsPerPage = action.payload
        },
        setGetAllValutazioniFiltersPage: (state, action) => {
            state.GetAllValutazioniFilters.page = action.payload
        },
        setGetAllValutazioniFiltersOrder: (state, action) => {
            state.GetAllValutazioniFilters.order = action.payload
        },
        setGetAllValutazioniFiltersSort: (state, action) => {
            state.GetAllValutazioniFilters.sort = action.payload
        },
        setGetAllFaseAvvioStartingDate: (state, action) => {
            state.GetAllValutazioniFilters.from = action.payload
        },
        setGetAllValutazioniValType: (state, action) => {
            state.GetAllValutazioniFilters.valType = action.payload
        },
        setGetAllValutazioniValM24User: (state, action) => {
            state.GetAllValutazioniFilters.validationM24User = action.payload
        },
        setGetAllValutazioniValVisitUser: (state, action) => {
            state.GetAllValutazioniFilters.validationVisitUser = action.payload
        },
        resetGetAllValutazioniFilters: (state) => {
            state.GetAllValutazioniFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder
            // GET ALL
            .addCase(GetAllValutazioni.pending, (state) => {
                state.getAllValutazioniStatus = 'loading'
            })
            .addCase(GetAllValutazioni.fulfilled, (state, action) => {
                state.getAllValutazioniStatus = 'successfully'
                state.GetAllValutazioniResponse = action.payload
            })
            .addCase(GetAllValutazioni.rejected, (state) => {
                state.getAllValutazioniStatus = 'failed'
            })
    },
})

export const {
    setGetAllValutazioniValType,
    setGetAllValutazioniFiltersItemsPerPage,
    setGetAllValutazioniFiltersOrder,
    setGetAllValutazioniFiltersPage,
    setGetAllValutazioniFiltersSort,
    setGetAllFaseAvvioStartingDate,
    setGetAllValutazioniValM24User,
    setGetAllValutazioniValVisitUser,
    resetGetAllValutazioniFilters
} = MonitoringValutazioniSlice.actions

export default MonitoringValutazioniSlice.reducer